import React from 'react'
import styles from './index.module.scss'
import PrimaryButton from '../button'
import bannerImg from '../../assets/UBF-Easter-Conf-Banner.png'
import { handleRegistrationScroll } from '../../../../utils/helper'

const BannerSection = () => {
  return (
    <section className={styles.banner_section}>
        <div className={styles.container}>
            <div className={styles.content}>
                <h3>Not Registered Yet?</h3> 
                <p>Join others that have registered and come experience the hand of God</p>
                <PrimaryButton onClick={handleRegistrationScroll} className={styles.banner_register}>Register Now</PrimaryButton>
            </div>
            <div className={styles.banner_img}>
                <img src={bannerImg} alt='banner img' />
            </div>
        </div>    
    </section>
  )
}

export default BannerSection